import { render } from "./DescendantTreePanel.vue?vue&type=template&id=f3318fc4"
import script from "./DescendantTreePanel.vue?vue&type=script&lang=js"
export * from "./DescendantTreePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__